import type { SpotEntryConfig } from '@myrewards/contracts';

/**
 * APP-225 (Tom: the nominator "just needs to get acknowledgement from the system that their
 * nomination's been acknowledged and it's in review"): what the nominator is told once it's sent,
 * the same on every route. They aren't told how it ends.
 */
export const NOMINATOR_ACK = 'Your nomination is with the Spot Committee for review.';
/** The last step after sending: nothing waits on the nominator, and nothing comes back to them. */
export const NOMINATOR_DONE =
  'Nothing else is needed from you. What you sent stays under My nominations.';

/**
 * Each route's words. APP-249 (S1, Q9): the nomination's intros name the title the letter prints,
 * never the Areté value, which is optional now. An `entryIntro` that says "Awards are paid in
 * cash." keeps that exact sentence: the Spot page swaps it for the cash range. `reviewIntro` is
 * the committee's review hero (S3).
 *
 * APP-268: new nominations take one route, so with no saved route to read these words are that
 * route's. `committee_only` stays for a nomination already sent that way.
 */
export function routeCopy(approvalMode: SpotEntryConfig['approvalMode'] | undefined) {
  if (approvalMode === 'committee_only') {
    return {
      whoDecides: 'The Spot Committee reviews each nomination and makes the final decision.',
      unspecifiedAmount: 'The Spot Committee decides',
      amountChoice: 'Let the committee decide',
      amountMeta: 'The Spot Committee decides the amount',
      entryIntro:
        'Tell the Spot Committee what your colleague did, with a short title for their letter. The committee makes the final decision, and awards are paid in cash.',
      firstEntryIntro:
        'Your first nomination takes about two minutes. Say who, give it a short title and say what they did; the Spot Committee makes the final decision.',
      sentIntro: NOMINATOR_ACK,
      reviewIntro:
        'Read the title and description, then approve an amount or decline for each colleague. The committee makes the final decision.',
      stages: ['The Spot Committee reviews each nomination and makes the final decision.'],
      stageTitle: 'The Spot Committee decides',
    };
  }
  return {
    whoDecides:
      'The Spot Committee recommends an award; the nominee’s supervisor makes the final decision.',
    unspecifiedAmount:
      'The Spot Committee recommends an amount; the nominee’s supervisor approves it.',
    amountChoice: 'Leave the amount open',
    amountMeta: 'The Spot Committee recommends an amount; the nominee’s supervisor approves it',
    entryIntro:
      'Tell the Spot Committee what your colleague did, with a short title for their letter. The committee recommends an award, then the nominee’s supervisor makes the final decision. Awards are paid in cash.',
    firstEntryIntro:
      'Your first nomination takes about two minutes. Say who, give it a short title and say what they did; the Spot Committee recommends an award, then the nominee’s supervisor makes the final decision.',
    sentIntro: NOMINATOR_ACK,
    reviewIntro:
      'Read the title and description, then recommend an amount for each colleague. Each colleague’s manager makes the final decision.',
    stages: [
      'The Spot Committee reviews the nomination and recommends an award and amount.',
      'The nominee’s supervisor makes the final award decision.',
    ],
    stageTitle: 'The Spot Committee recommends',
  };
}
